module.exports = {
  systemID: process.env.REACT_APP_SYSTEM_ID,
  apiGatewayURL: process.env.REACT_APP_APIGATEWAY_URL,
  stageName: process.env.REACT_APP_STAGE_NAME,
  timezone: '8',
  bpmsURL: process.env.REACT_APP_BPMS_URL,
  apiGatewayRfdmeURL: process.env.REACT_APP_APIGATEWAY_RFDME_URL,
};
